import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
	const { resolvedTheme, setTheme } = useTheme();
	const dark = resolvedTheme === "dark";
	return (
		<button
			type="button"
			aria-label="Toggle theme"
			className="inline-flex size-9 items-center justify-center rounded-full border border-border/60 bg-card/80 text-muted-foreground hover:text-foreground"
			onClick={() => setTheme(dark ? "light" : "dark")}
		>
			{dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
		</button>
	);
}
